const BannerSticky = ()=>{
    if (process.env.PLUGIN_CTX === "pro") {
    /* Silence is golden... Until you have PRO Version! */ } else {
        return null;
    }
};
export { BannerSticky };
